import { theme } from '_constants/theme';
import styled from 'styled-components';
import getConfig from 'next/config';

const { colors, devices, fontSizes, spaces } = theme;
const { publicRuntimeConfig } = getConfig();

const StyledProtectBusinessSection = styled.div`
  max-width: ${spaces.large24X * 10 + 80}px;
  width: 100%;
  margin-top: ${spaces.large24X}px;
  margin-bottom: ${spaces.large24X}px;
  display: flex;
  flex-direction: column;
  .headerSection {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 500;
    font-size: ${fontSizes.large11X}px;
    line-height: 130%;
    text-align: center;
    color: ${colors.gray[800]};
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
  }
  .columnDesktopContainer {
    display: flex;
    margin-top: ${spaces.large7X - 2}px;
    justify-content: center;
    gap: 30px;
    .description {
      font-size: ${fontSizes.large}px;
      line-height: 150%;
      font-family: 'Aeonik';
      font-style: normal;
      font-weight: 400;
      text-align: center;
      color: ${colors.gray[800]};
    }
  }
  @media ${devices.laptopM} {
    padding-left: ${spaces.large2X}px;
    padding-right: ${spaces.large2X}px;
  }
  @media ${devices.tablet} {
    margin-top: ${spaces.large9X}px;
    margin-bottom: ${spaces.large9X}px;
    margin-left: 0;
    margin-right: 0;
    padding: 0px ${spaces.regular}px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0px;
    flex: none;
    order: 1;
    flex-grow: 0;
    .headerSection {
      padding: 0px ${spaces.regular}px;
      font-size: ${fontSizes.large2X}px;
      line-height: 150%;
    }
    .columnDesktopContainer {
      flex-direction: column;
      width: 100%;
      margin-top: ${spaces.large2X}px;
      .description {
        font-size: ${fontSizes.large}px;
        line-height: 150%;
        font-family: 'Aeonik';
        font-style: normal;
        font-weight: 400;
        text-align: center;
        color: ${colors.gray[800]};
        width: 100%;
      }
    }
  }
`;
const StyledProduct = styled.div`
  width: 33.33%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px;
  gap: 20px;
  background: ${({ color }) => color};
  border-radius: 16px;

  img {
    width: 80px;
  }
  .container .description {
    margin-top: ${spaces.small - 2}px;
  }
  @media ${devices.laptopM} {
    img {
      width: ${spaces.large24X}px;
    }
  }
  @media ${devices.tablet} {
    padding: 16px;
    flex-direction: row;
    width: initial;
    justify-content: space-between;
    img {
      width: 60px;
    }
  }
`;
const products = [
  {
    color: `${colors.blue[50]}`,
    description: 'Trademark Registration',
    icon: `${publicRuntimeConfig.basePath}/images/clipboard.svg`,
  },
  {
    color: `${colors.orange[50]}`,
    description: 'Trademark Alert Monitoring',
    icon: `${publicRuntimeConfig.basePath}/images/bell-ring.svg`,
  },
  {
    color: `${colors.green[50]}`,
    description: 'Trademark Renewals',
    icon: `${publicRuntimeConfig.basePath}/images/favourite.svg`,
  },
];
const ProtectBusinessSection = () => {
  return (
    <StyledProtectBusinessSection>
      <div className="headerSection">
        Protect Your Business with our Services
      </div>
      <div className="columnDesktopContainer">
        {products.map((step, idx) => {
          const { color, description, icon } = step;
          return (
            <StyledProduct color={color} key={`step:${idx}`}>
              <picture>
                <source srcSet={icon} type="image/png" />
                <img src={icon} alt="" />
              </picture>
              <div className="description">{description}</div>
            </StyledProduct>
          );
        })}
      </div>
    </StyledProtectBusinessSection>
  );
};

export default ProtectBusinessSection;
